import { IIdsRequest } from "../../model/request/IIdsRequest";
import { ICaThi } from "../../model/respone/tct/ICaThi";
import { apiClient } from "../apiClient";

export const CA_THI_RESOURCE = "ca-thi";
export const caThiApi = {
  SelectAll: () => apiClient.get(`${CA_THI_RESOURCE}`),
  Insert: (payload: ICaThi) => apiClient.post(`${CA_THI_RESOURCE}`, payload),
  Update: (payload: ICaThi) => apiClient.put(`${CA_THI_RESOURCE}`, payload),
  Delete: (id: number) => apiClient.delete(`${CA_THI_RESOURCE}/${id}`),
  Deletes: (ids: IIdsRequest) => apiClient.put(`${CA_THI_RESOURCE}/deletes`,ids),
};
